import classNames from 'classnames'
import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Company } from '../../../../../model/company.model'
import { useAppSelector } from '../../../../../redux/hooks'
import { findCompanyById } from '../../../../../util/arraySearch'

export const CompanyDropdown = (props: {
  fieldName?: string | undefined;
}): JSX.Element => {
  const companies: Company[] = useAppSelector((state) => state.companies)

  const dummyCompany: Company = {
    company_name: t<string>('core.no_specification'),
    company_id: 0,
  }

  const { control } = useFormContext()

  const selectedCompanyTemplate = (companyId: number | undefined) => {
    if (!companyId) {
      return undefined
    }

    const company = findCompanyById(companyId, companies)

    if (company) {
      if (company?.address) {
        return (
          <div className={'flex align-items-center'}>
            <span>{company.company_name}</span>
            <span className={'small-text secondary-text ml-auto'}>
              <span className={'fa-solid fa-location-dot icon-gray'} />{' '}
              {company.address}
            </span>
          </div>
        )
      }
      return <span>{company.company_name}</span>
    }
  }

  /**
   * Return the Company to select
   * @param {Company} company
   * @returns {JSX.Element | undefined}
   */
  const companyOptionTemplate = (company: Company) => {
    if (!company?.address) {
      return <>{company.company_name}</>
    }
    return (
      <div className={'flex align-items-center'}>
        <span>{company.company_name}</span>
        <span className={'small-text secondary-text ml-auto'}>
          <span className={'fa-solid fa-location-dot icon-gray'} />{' '}
          {company.address}
        </span>
      </div>
    )
  }

  return (
    <Controller
      name={props.fieldName ? props.fieldName : 'id_company'}
      control={control}
      render={({ field, fieldState }) => (
        <Dropdown
          id={field.name}
          appendTo={document.body}
          options={companies ? [dummyCompany].concat(companies) : companies}
          onChange={(e) => {
            // we have the Company object and want to set the id
            field.onChange(e.target.value?.company_id)
          }}
          optionLabel="company_name"
          placeholder={t<string>('core.select')}
          filter
          showClear
          filterBy="company_name"
          valueTemplate={selectedCompanyTemplate(field.value)}
          itemTemplate={companyOptionTemplate}
          emptyMessage={t<string>('core.empty_message')}
          emptyFilterMessage={t<string>('core.empty_filter_message')}
          className={classNames({ 'p-invalid': fieldState.error }, ' w-full')}
        />
      )}
    />
  )
}

export default CompanyDropdown